export default class Districts {
  public id: string = '';

  public nome: string = '';

  constructor(data: any = {}) {
    this.id = data.id || '';
    this.nome = data.nome || '';
  }
}
